import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { IKlantGroepModel } from 'shared/models/IKlantGroepModel'
import { IOrderType } from 'shared/models/IOrderType'
import { isCheckboxSelected, toggleCheckbox } from '../utils/utils'

interface IProps {
  possibleOrderTypes: IOrderType[]
  disabled: boolean
}

const OrderTypeControl: FC<IProps> = ({ possibleOrderTypes, disabled }) => {
  const { control } = useFormContext<IKlantGroepModel>()

  return (
    <Controller
      control={control}
      name='orderType'
      render={({ field }) => {
        const allSelected = possibleOrderTypes.every(ot =>
          isCheckboxSelected(field.value, ot.value)
        )

        const toggleAll = () => {
          if (allSelected) {
            field.onChange('') // Deselect all
          } else {
            field.onChange(possibleOrderTypes.map(ot => ot.value).join(',')) // Select all
          }
        }

        return (
          <div className='row'>
            <div className='col-10'>
              {possibleOrderTypes.map(orderType => (
                <div key={orderType.value}>
                  <input
                    type='checkbox'
                    id={`orderType-${orderType.value}`}
                    checked={isCheckboxSelected(field.value, orderType.value)}
                    disabled={disabled}
                    onChange={() =>
                      field.onChange(
                        toggleCheckbox(field.value, orderType.value)
                      )
                    }
                  />
                  <label
                    htmlFor={`orderType-${orderType.value}`}
                    className='ml-1'
                  >
                    {orderType.name} ({orderType.value})
                  </label>
                </div>
              ))}
            </div>

            <div
              className='col-2'
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <label htmlFor='orderType-all'>alle</label>
              <input
                type='checkbox'
                id='orderType-all'
                checked={allSelected}
                disabled={disabled}
                onChange={toggleAll}
              />
            </div>
          </div>
        )
      }}
    />
  )
}

export default OrderTypeControl
